import React from 'react';
import { Asset as ContentfulAsset } from 'contentful';

import { IOverlayHeroFields } from '../../../types/contentful';

import RichText from '../RichText';
import { Asset } from '../AtomicComponents/Asset';

export function OverlayHero({
  headingText,
  copy,
  desktopHeadingText,
  desktopCopy,
  image,
  useLightText,
  desktopImage
}: IOverlayHeroFields) {
  return (
    <section
      className="mb-1 mt-3 flex w-full scroll-mt-16 justify-center tablet:mb-16 desktop:mb-4"
      data-blockid="overlay-hero"
      data-testid="overlay-hero-block"
      data-e2e="hero"
    >
      <div className="w-full max-w-[1440px] px-3 tablet:px-12">
        <div className="relative z-0 overflow-hidden rounded-[64px] desktop:rounded-[104px]">
          <div className="hidden tablet:block">
            <Asset asset={desktopImage as ContentfulAsset} loading="eager" />
          </div>

          <div
            id="no-overflow-box"
            className="relative z-0 overflow-hidden rounded-[64px] desktop:rounded-[104px]"
          >
            <div className="block tablet:hidden">
              <Asset asset={image as ContentfulAsset} loading="eager" />
            </div>
          </div>
          <div className="mx-auto text-center tablet:absolute tablet:bottom-0 tablet:left-0 tablet:right-0 tablet:top-[40%] tablet:z-[1] tablet:-translate-y-[40%] tablet:text-left">
            <div className="w-full min-w-0 flex-1">
              <div className="-mx-3 flex flex-wrap justify-center desktop:mx-0">
                <div className="column w-2/3 flex-col px-3 py-6 tablet:w-5/6 tablet:py-3 desktop:px-0">
                  <div className="mb-4">
                    <h1
                      className={`typography-display-3 tablet:hidden ${
                        useLightText && 'tablet:text-white'
                      }`}
                      dangerouslySetInnerHTML={{
                        __html: headingText || ''
                      }}
                    />
                    <h1
                      className={`typography-display-2 hidden tablet:block ${
                        useLightText && 'tablet:text-white'
                      }`}
                      dangerouslySetInnerHTML={{
                        __html: desktopHeadingText || headingText || ''
                      }}
                    />
                  </div>

                  {copy && (
                    <div className="tablet:hidden">
                      <RichText
                        data={copy}
                        colour={{
                          0: 'defaultText',
                          tablet: useLightText ? 'white' : 'defaultText'
                        }}
                      />
                    </div>
                  )}
                  {(copy || desktopCopy) && (
                    <div className="hidden tablet:block">
                      <RichText
                        data={desktopCopy || copy}
                        colour={{
                          0: 'defaultText',
                          tablet: useLightText ? 'white' : 'defaultText'
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
